var CryptoJS = require("crypto-js");

/** Must match backend USER_MERCHANT_KEY / USER_API_KEY (see utils/authuser.js) */
const merchantKey =
  process.env.REACT_APP_MERCHANT_KEY ||
  "025ca5a7857547255f4ba97510ee2d631e1d79469a21048e197029ca11fac02c";
const merchantId =
  process.env.REACT_APP_MERCHANT_ID ||
  "fa515ac8f0ce5fc27f7a102d05234ea9";

if (!merchantKey || !merchantId) {
  console.error("Environment variables REACT_APP_MERCHANT_KEY or REACT_APP_MERCHANT_ID are missing.");
  throw new Error("Missing environment variables for merchant configuration.");
}

function generateNonce() {
  return Math.random().toString(36).substring(2); // Random string
}

function generateSignature(queryString, merchantKey) {
  if (!queryString || !merchantKey) {
    console.error("Invalid inputs to generateSignature:", { queryString, merchantKey });
    throw new Error("Invalid inputs to generateSignature.");
  }
  const hmac = CryptoJS.HmacSHA256(queryString, merchantKey);
  return CryptoJS.enc.Base64.stringify(hmac);
}

function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

function buildSignedHeaders(contentType, includeAuth = true) {
  const timestamp = Math.floor(Date.now() / 1000);
  const nonce = generateNonce();
  const params = {
    'x-api-key': merchantId,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
  };

  const sortedParams = sortObject(params);
  const queryString = new URLSearchParams(sortedParams).toString();
  const signature = generateSignature(queryString, merchantKey);

  const headers = {
    'Content-Type': contentType,
    'x-api-key': merchantId,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
    'X-Sign': signature,
  };

  if (includeAuth) {
    const myToken = localStorage.getItem('token');
    if (myToken) {
      headers.authorization = myToken;
    }
  }

  return headers;
}

/** Signed headers for authenticated user API calls */
export default async function getSignature() {
  try {
    return buildSignedHeaders('application/x-www-form-urlencoded', true);
  } catch (e) {
    console.error('Error generating signature:', e);
    throw e;
  }
}

/** Signed headers for public endpoints — no Authorization header */
export async function getPublicHeaders(contentType = 'application/json') {
  try {
    return buildSignedHeaders(contentType, false);
  } catch (e) {
    console.error('Error generating public headers:', e);
    throw e;
  }
}
